import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import {
  LOAD_CONTENT,
  SET_DATA,
  SUBMIT_ORDER,
  DL_PAGE_LOADED
} from './review';
import loader from '../../../../../util/loader/loader';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';

// WATCHERS
export function* loadCustomerWatch() {
  yield takeLatest(LOAD_CONTENT, loadCustomerWorker);
}

export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

export function* submitOrderWatch() {
  yield takeLatest(SUBMIT_ORDER, submitOrderWorker);
}

// WORKERS
export function* loadCustomerWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true}));

    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'},
      {state: 'moversReview'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());
  } catch(e) {
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.movers.ERROR].path);
  }
}

export function* normalizeWorker({key, data, meta}) {
  if (key !== 'moversReview') {
    return;
  }

  yield put({
    type: SET_DATA,
    payload: {
      ...meta,
      content: data
    }
  });
}

export function* submitOrderWorker() {
  try {
    const errorPage = yield select(errorPageByFlow);

    const data = {
      isVerified: true,
      orderType: 'Disconnect'
    };

    const endpoint = navigationRoutes[navigationSteps.movers.REVIEW].endpoints.submitOrder();
    const success = yield call(loader.request, endpoint, {data, hideContentWhileLoading: false, errorPage});

    if (!success) {
      return;
    }

  } catch(e) {
    //console.log(e)
  }
}

export default function* moversCancelSagas() {
  yield [
    fork(loadCustomerWatch),
    fork(normalizeWatch),
    fork(submitOrderWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/review/reviewSagas.js
 **/